import { useQuery } from "@tanstack/react-query";

import type { ICountryObject } from "app/services/CountryService";

import { createKeyword } from "./createKeyword";
import { KEYWORDS_VOLUMES_PATHNAME, getEnrichedKeywords } from "./utils/getEnrichedKeywords";

export const useKeywordSuggestion = (query: string, country: ICountryObject) => {
    const createdKeywords = [createKeyword({ term: query, isRecentlyAdded: true, isLoading: true })];

    return useQuery({
        queryKey: [KEYWORDS_VOLUMES_PATHNAME, "suggestion", query, country.id],
        queryFn: async ({ signal }) => getEnrichedKeywords(createdKeywords, country, signal),
        enabled: query.length > 0,
        select: (data) => ({ ...data[0], isRecentlyAdded: true, isLoading: false }),
        initialData: createdKeywords,
    });
};
